<template functional>
  <div
    :class="data.staticClass"
    :style="{ backgroundColor: props.careType.color }"
    class="CareIcon"
    v-bind="{...data.attrs, [parent.$options._scopeId]: ''}"
    v-on="listeners"
  >
    <div class="img-wrap">
      <img :src="`/images/care/${props.careType.image}`" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'CareIcon',
  props: {
    careType: {},
  },
}
</script>

<style scoped lang="scss">
$size: 95%;
$padding: (100% - $size) / 2;

.CareIcon {
  position: relative;
  overflow: hidden;
  border-radius: 50%;
  background: #cccccc;

  &::before {
    display: block;
    padding-top: 100%;
    content: '';
  }
}
.img-wrap {
  position: absolute;
  top: $padding;
  left: $padding;
  width: $size;
  height: $size;

  img {
    width: 100%;
  }
}
</style>
